import { render, staticRenderFns } from "./SSDashBoard.vue?vue&type=template&id=60955307&scoped=true&"
import script from "./SSDashBoard.vue?vue&type=script&lang=js&"
export * from "./SSDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./SSDashBoard.vue?vue&type=style&index=0&id=60955307&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60955307",
  null
  
)

export default component.exports